import { getUploadedFiles } from '../../../../services/Opportunities';
import { IAnomalyCommentsResponseModel } from '../../../../models/IOpportunitiesAPIModel';

export const getReviewerUploadedFiles = async (opportunityId: number) => {
  // The legacy service declares reasons[], but user-activity returns an activity response.
  const response: unknown = await getUploadedFiles(opportunityId);
  return response as IAnomalyCommentsResponseModel;
};
